import request from '@/request'

export async function getTrailIndex() {
  const response = await request({
    url: `/v2/trails`,
    method: 'get'
  })

  return response.data
}

export async function pickTrail(trailId) {
  const response = await request({
    url: `/v2/trails/${trailId}/pick`,
    method: 'post'
  })

  return response.data
}

export async function getTrailCourses(trailId) {
  const response = await request({
    url: `/v2/trails/${trailId}`,
    method: 'get'
  })

  return response.data
}

export async function getUserTrail(userId = 'me') {
  const response = await request({
    url: `/v2/users/${userId}/trail`,
    method: 'get'
  })

  return response.data
}